import { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps, SystemStyleObject } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import { ButtonGroupProps } from './ButtonGroup';

const ButtonGroup: ComponentStyleConfig = {
  baseStyle: (props: ButtonGroupProps & StyleFunctionProps): SystemStyleObject => ({
    '& > *:not(style) ~ *:not(style)': {
      marginStart: props.isAttached ? 0 : props.spacing
    },
    '> *:first-of-type:not(:last-of-type)': {
      borderEndRadius: props.isAttached ? 0 : '',
      borderRightHeight: props.isAttached ? '100%' : '',
      borderRightWidth: props.isAttached ? 0 : '',
      borderRightColor: props.isAttached ? mode('rgba(18, 21, 26, 0.24)', 'black.base')(props) : ''
    },
    '> *:not(:first-of-type):not(:last-of-type)': {
      borderRadius: props.isAttached ? 0 : ''
    },
    '> *:not(:first-of-type):last-of-type': {
      borderStartRadius: props.isAttached ? 0 : '',
      minWidth: props.isAttached ? 0 : '',
      _disabled: {
        boxShadow: props.isAttached
          ? mode('inset 1px 0px 0px 0px rgba(18, 21, 26, 0.16)', 'inset 1px 0px 0px 0px rgba(18, 21, 26, 0.32)')(props)
          : ''
      },
      svg: {
        width: props.isAttached ? props.theme.fontSizes[props.size] : '',
        height: props.isAttached ? props.theme.fontSizes[props.size] : ''
      }
    },
    button: {
      boxShadow: props.isAttached
        ? ''
        : '0px 4px 12px -8px rgba(18, 21, 26, 0.24), 0px 4px 8px -8px rgba(18, 21, 26, 0.24), inset 0px 0px 0px 1px rgba(18, 21, 26, 0.16)',
      _active: {
        bg: props.isAttached ? mode('silver.light', 'grey.base')(props) : ''
      },
      marginRight: '-1px'
    },
    display: 'inline-flex',
    padding: props.isAttached ? '1px' : ''
  }),
  sizes: {
    xs: {
      borderRadius: '7px',
      button: {
        borderRadius: '6px',
        fontSize: '12px',
        height: '24px'
      }
    },
    sm: {
      borderRadius: '9px',
      button: {
        borderRadius: '8px',
        fontSize: '14px',
        height: '32px'
      }
    },
    md: {
      borderRadius: '11px',
      button: {
        borderRadius: '10px',
        fontSize: '17px',
        height: '40px'
      }
    },
    lg: {
      borderRadius: '13px',
      button: {
        borderRadius: '12px',
        fontSize: '20px',
        height: '48px'
      }
    }
  }
};

export default ButtonGroup;
